import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import portal, { CuentaDelAlumno, MensualidadDelAlumno } from "../../../services/v2/portalAlumno.service";
import { Dinero, dinero } from "./portalComun";
import "./portal.css";

/*
	Mi Estado de Cuenta (alumno, solo lectura). La pantalla de Finanzas usa rutas /admin que un token de
	alumno no puede tocar, así que el portal trae sus mensualidades de /scholar/_statement.
*/
const MiEstadoDeCuenta: React.FC = () => {
	const [datos, setDatos] = useState<{ account: CuentaDelAlumno; tuitions: MensualidadDelAlumno[] } | null>(null)
	const [error, setError] = useState<boolean>(false)
	const navigate = useNavigate()
	useEffect(() => {
		let vivo = true
		portal.statement().then((r) => { if (vivo) setDatos(r.data) }).catch(() => { if (vivo) setError(true) })
		return () => { vivo = false }
	}, [])
	if (error) return <div className="pt"><div className="ptVacio">No Pudimos Cargar Tu Estado De Cuenta</div></div>
	if (datos === null) return <div className="pt"><div className="ptPagina ptUna"><div className="ptVacio">Cargando…</div></div></div>
	const { account, tuitions } = datos
	return (
		<div className="pt">
			<div className="ptPagina ptUna">
				<div className="ptColumna">
					<h1 className="ptH1">Mi Estado De Cuenta</h1>
					<div className={"ptTarjeta" + (account.hasOverdue ? " ptVencido" : "")}>
						<div className="ptVencidoFila">
							<div className="ptDato">
								<span className="ptTenue ptChico">{account.hasOverdue ? "Saldo Vencido" : "Mensualidades"}</span>
								{account.hasOverdue
									? <span className="ptMonto ptOro">{account.overdue.map((m) => <div key={m.currency}><Dinero m={m} /></div>)}</span>
									: <span className="ptMonto">Al Corriente</span>}
							</div>
							{account.hasOverdue && account.oldestOverdue
								? <div className="ptDato"><span className="ptTenue ptChico">Venció</span><span className="ptFecha">{account.oldestOverdue.dueLabel}</span></div>
								: account.nextDueLabel ? <div className="ptDato"><span className="ptTenue ptChico">Próximo Pago</span><span className="ptFecha">{account.nextDueLabel}</span></div> : null}
						</div>
						{account.hasOverdue ? <div className="ptAcciones"><button type="button" className="ptBoton" onClick={() => navigate("/reportarPago")}>Reportar Mi Pago</button></div> : null}
					</div>
					{tuitions.length === 0 ? <div className="ptVacio">Aún No Tienes Mensualidades</div> : (
						<div className="ptLista">
							<div className="ptFila ptTablaCabeza" aria-hidden="true">
								<span className="ptCol1">Concepto</span><span className="ptCol2">Vence</span><span className="ptCol3">Monto</span><span className="ptCol3">Saldo</span><span className="ptCol4">Estado</span>
							</div>
							{tuitions.map((t) => (
								<div className="ptFila ptTablaFila" key={t.id}>
									<span className="ptCol1 ptFilaTitulo">{t.title}</span>
									<span className="ptCol2 ptTenue">{t.dueLabel}</span>
									<span className="ptCol3">{dinero(t.amount, t.symbol)}</span>
									<span className="ptCol3">{dinero(t.balance, t.symbol)}</span>
									<span className={"ptCol4 ptMensualidad ptMensualidad-" + t.status}>{t.statusLabel}</span>
								</div>
							))}
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default MiEstadoDeCuenta
